<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">历史号码统计</span>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <div v-if="liShiHaoMaStatsList" class="content-8__content">
        <table class="even-color">
          <thead>
            <tr>
              <th style="width: 300px;">日期</th>
              <th v-for="column in columnKeys" :key="column.key">{{ column.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rowData in liShiHaoMaStatsList" :key="`${rowData.date}`">
              <td>{{ rowData.date }}</td>
              <template v-for="column in columnKeys">
                <td :key="`tbody-${rowData.date}-${column.key}`">
                  {{ Math.abs(rowData[column.key]) }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { fieldList } from '@/utils/forWeb-Sean/liShiHaoMa'
import { getCPStatistics_web } from '@/api/desktop/statistic'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'WebLiShiHaoMaTongJi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      isLoading: true,
      lotteryCode: this.$route.params.lottery_code,
      liShiHaoMaStatsList: null
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.getLiShiHaoMaStatistics(this.lotteryCode)
  },
  methods: {
    async getLiShiHaoMaStatistics(code) {
      this.isLoading = true
      const [data, error] = await getCPStatistics_web(code, 'dxdsHistory', {
        days: 30,
        rules: 'balls,hmDaXiao'
      })
      if (error) return
      this.liShiHaoMaStatsList = data.map(each => {
        return Object.assign({}, {
          date: each.date,
          ...each.countList.balls,
          ...each.countList.hmDaXiao
        })
      })
      this.isLoading = false
    }
  }
}
</script>
